import { IconProps } from "@/@types/general";

export const IconPlay = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <path d="M35.6482 18.9336L13.1518 5.18536C12.9623 5.06956 12.7454 5.00633 12.5234 5.00217C12.3014 4.99801 12.0822 5.05308 11.8886 5.1617C11.6949 5.27033 11.5336 5.42859 11.4214 5.62021C11.3092 5.81183 11.25 6.02989 11.25 6.25195V33.7484C11.25 33.9705 11.3092 34.1885 11.4214 34.3801C11.5336 34.5718 11.6949 34.73 11.8886 34.8386C12.0822 34.9473 12.3014 35.0023 12.5234 34.9982C12.7454 34.994 12.9623 34.9308 13.1518 34.815L35.6482 21.0668C35.8309 20.9551 35.9819 20.7984 36.0866 20.6116C36.1913 20.4249 36.2463 20.2143 36.2463 20.0002C36.2463 19.786 36.1913 19.5755 36.0866 19.3887C35.9819 19.202 35.8309 19.0452 35.6482 18.9336Z" />
  </svg>
);
export const IconPause = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <g clipPath="url(#clip0_1044_26971)">
      <path d="M31.25 6.25H25.625C24.9346 6.25 24.375 6.80964 24.375 7.5V32.5C24.375 33.1904 24.9346 33.75 25.625 33.75H31.25C31.9404 33.75 32.5 33.1904 32.5 32.5V7.5C32.5 6.80964 31.9404 6.25 31.25 6.25Z" />
      <path d="M14.375 6.25H8.75C8.05964 6.25 7.5 6.80964 7.5 7.5V32.5C7.5 33.1904 8.05964 33.75 8.75 33.75H14.375C15.0654 33.75 15.625 33.1904 15.625 32.5V7.5C15.625 6.80964 15.0654 6.25 14.375 6.25Z" />
    </g>
  </svg>
);

export const IconVolume = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <g clipPath="url(#clip0_1044_27497)">
      <path d="M5 14.9995V24.9995H11.6667L20 33.3328V6.66615L11.6667 14.9995H5ZM27.5 19.9995C27.5 17.0495 25.8 14.5161 23.3333 13.2828V26.6995C25.8 25.4828 27.5 22.9495 27.5 19.9995ZM23.3333 5.38281V8.81615C28.15 10.2495 31.6667 14.7161 31.6667 19.9995C31.6667 25.2828 28.15 29.7495 23.3333 31.1828V34.6161C30.0167 33.0995 35 27.1328 35 19.9995C35 12.8661 30.0167 6.89948 23.3333 5.38281Z" />
    </g>
  </svg>
);

export const IconVolumeOff = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3.01562 14.9998V24.9998H9.68229L18.0156 33.3332V6.6665L9.68229 14.9998H3.01562Z" fill="white" />
    <path d="M25.189 25.1733L23.3276 23.3119L26.6817 19.9579L23.3697 16.6459L25.1388 14.8768L28.4508 18.1888L31.8128 14.8267L33.6742 16.6881L30.3122 20.0502L33.6241 23.3621L31.855 25.1312L28.5431 21.8193L25.189 25.1733Z" />
  </svg>
);

export const IconSeekBack = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1044_27490)">
      <path
        d="M7.14654 21.1426C7.17503 24.7547 8.58131 28.3767 11.3578 31.1532C16.9125 36.7079 25.8471 36.7774 31.314 31.3104C36.781 25.8435 36.7114 16.9089 31.1568 11.3542C25.603 5.8004 16.6675 5.72999 11.2005 11.197M11.2005 11.197L10.3368 7.03278M11.2005 11.197L15.3652 12.0612M7.03704 10.3326L7.90129 14.4967L12.0654 15.361"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.8525 26.125V17.5664H16.8252L14.2139 19.4463V18.1475L16.8389 16.2607H18.042V26.125H16.8525ZM23.9961 26.2891C21.6924 26.2891 20.3594 24.3066 20.3594 21.1895C20.3594 18.0996 21.7061 16.0967 23.9961 16.0967C26.2861 16.0967 27.6191 18.0859 27.6191 21.1826C27.6191 24.2998 26.293 26.2891 23.9961 26.2891ZM23.9961 25.2158C25.5342 25.2158 26.3818 23.6504 26.3818 21.1895C26.3818 18.7627 25.5205 17.1768 23.9961 17.1768C22.4717 17.1768 21.5967 18.7764 21.5967 21.1826C21.5967 23.6436 22.4512 25.2158 23.9961 25.2158Z" />
    </g>
  </svg>
);
export const IconSeekForward = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1044_27493)">
      <path
        d="M32.8535 21.1426C32.825 24.7547 31.4187 28.3767 28.6422 31.1532C23.0875 36.7079 14.1529 36.7774 8.68598 31.3104C3.21901 25.8435 3.28855 16.9089 8.84321 11.3542C14.397 5.8004 23.3325 5.72999 28.7995 11.197M28.7995 11.197L29.6632 7.03278M28.7995 11.197L24.6348 12.0612M32.963 10.3326L32.0987 14.4967L27.9346 15.361"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M14.7783 26.125V17.5664H14.751L12.1396 19.4463V18.1475L14.7646 16.2607H15.9678V26.125H14.7783ZM21.9219 26.2891C19.6182 26.2891 18.2852 24.3066 18.2852 21.1895C18.2852 18.0996 19.6318 16.0967 21.9219 16.0967C24.2119 16.0967 25.5449 18.0859 25.5449 21.1826C25.5449 24.2998 24.2188 26.2891 21.9219 26.2891ZM21.9219 25.2158C23.46 25.2158 24.3076 23.6504 24.3076 21.1895C24.3076 18.7627 23.4463 17.1768 21.9219 17.1768C20.3975 17.1768 19.5225 18.7764 19.5225 21.1826C19.5225 23.6436 20.377 25.2158 21.9219 25.2158Z" />
    </g>
  </svg>
);

export const IconFullscreen = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <g clipPath="url(#clip0_1044_27482)">
      <path d="M11.6654 23.332H8.33203V31.6654H16.6654V28.332H11.6654V23.332ZM8.33203 16.6654H11.6654V11.6654H16.6654V8.33203H8.33203V16.6654ZM28.332 28.332H23.332V31.6654H31.6654V23.332H28.332V28.332ZM23.332 8.33203V11.6654H28.332V16.6654H31.6654V8.33203H23.332Z" />
    </g>
  </svg>
);

export const IconArrowLeft = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" viewBox="0 0 50 40" fill="none" {...props}>
    <path d="M45 20H6.25" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 8.75L6.25 20L17.5 31.25" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChatCenteredDots = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <path
      d="M23.3859 31.4669L21.0719 35.3837C20.9608 35.5716 20.8037 35.7272 20.6159 35.8352C20.428 35.9432 20.2159 36 20 36C19.7841 36 19.572 35.9432 19.3841 35.8352C19.1963 35.7272 19.0392 35.5716 18.9281 35.3837L16.6141 31.4669C16.5031 31.2789 16.346 31.1233 16.1581 31.0153C15.9703 30.9073 15.7581 30.8506 15.5423 30.8506H6.25C5.91848 30.8506 5.60054 30.7168 5.36612 30.4787C5.1317 30.2407 5 29.9178 5 29.5811V9.26948C5 8.93279 5.1317 8.6099 5.36612 8.37182C5.60054 8.13375 5.91848 8 6.25 8H33.75C34.0815 8 34.3995 8.13375 34.6339 8.37182C34.8683 8.6099 35 8.93279 35 9.26948V29.5811C35 29.7479 34.9677 29.9129 34.9048 30.067C34.842 30.221 34.75 30.3609 34.6339 30.4788C34.5178 30.5967 34.38 30.6902 34.2283 30.754C34.0767 30.8178 33.9141 30.8506 33.75 30.8506L24.4577 30.8506C24.2419 30.8506 24.0297 30.9073 23.8419 31.0153C23.654 31.1233 23.4969 31.2789 23.3859 31.4669Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z"
      fill="white"
    />
    <path
      d="M24 21C25.1046 21 26 20.1046 26 19C26 17.8954 25.1046 17 24 17C22.8954 17 22 17.8954 22 19C22 20.1046 22.8954 21 24 21Z"
      fill="white"
    />
  </svg>
);
export const IconDecreaseVolume = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 14.9998V24.9998H12.1667L20.5 33.3332V6.6665L12.1667 14.9998H5.5Z" fill="white" />
    <path d="M22.5 21.316V18.6836H27.2434L29.7453 18.6875V18.6836H34.5V21.316H29.7453H27.2434H22.5Z" fill="white" />
  </svg>
);
export const IconIncreaseVolume = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.5 14.9998V24.9998H12.1667L20.5 33.3332V6.6665L12.1667 14.9998H5.5Z" fill="white" />
    <path
      d="M22.5 21.3162V18.6838H27.2434V14H29.7453V18.6838H34.5V21.3162H29.7453V26H27.2434V21.3162H22.5Z"
      fill="white"
    />
  </svg>
);
export const IconPictureInPicture = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <path
      d="M33.75 8.75H6.25C5.55964 8.75 5 9.30964 5 10V30C5 30.6904 5.55964 31.25 6.25 31.25H33.75C34.4404 31.25 35 30.6904 35 30V10C35 9.30964 34.4404 8.75 33.75 8.75Z"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.25 31.25V21.25C21.25 20.9185 21.3817 20.6005 21.6161 20.3661C21.8505 20.1317 22.1685 20 22.5 20H35"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconFaders = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <path d="M20.625 20L6.25 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M33.75 20L26.875 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.125 31.25L6.25 31.2501" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M33.75 31.2501L14.375 31.25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.375 35L14.375 27.5" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.125 8.75007L6.25 8.75" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M33.75 8.75L19.375 8.75007" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.375 5L19.375 12.5" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M26.875 23.75L26.875 16.25" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const IconSkipNext = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <g clipPath="url(#clip0_1044_27473)">
      <path d="M10 30L24.1667 20L10 10V30ZM26.6667 10V30H30V10H26.6667Z" fill="white" />
    </g>
  </svg>
);
export const IconSeries = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none" {...props}>
    <path d="M5 24L20 32.75L35 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5 16.5L20 25.25L35 16.5L20 7.75L5 16.5Z"
      fill="white"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBroadcasts = (props: IconProps): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="7" width="16" height="12" rx="2" stroke="white" strokeWidth="2" />
    <path d="M9 5L12 8L15 5" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
